export default __webpack_public_path__ + "static/media/AKM_4.82904fed.png";